import { Project } from "./types";
import falkenholzShowcase from "../assets/falkenholz-showcase-mobile.webp";
import reactIcon from "../assets/react-icon.svg";
import typescriptIcon from "../assets/typescript-icon.svg";
import sassIcon from "../assets/sass-icon.svg";
import threejsIcon from "../assets/Threejs-logo.svg";

export const falkenholzProject: Project = {
  title: "Falkenholz 3D Configurator",
  description:
    "For Falkenholz, a custom traditional recurve bow company, I developed a 3D configurator that allows users to customize their bows in real-time. The project was built using Three.js for 3D rendering and React for the user interface. This configurator enhances user engagement by providing an interactive experience, allowing customers to visualize their custom designs before making a purchase.",
  date: "02/2025 - 12/2025",
  image: falkenholzShowcase,
  imageAlt: "Falkenholz 3D Configurator project showcase",
  link: "https://falkenholz-prototyp.vercel.app",
  technologies: [threejsIcon, reactIcon, typescriptIcon, sassIcon],
};
